export enum BasketApiErrors {
    BASKET_LOCKED = 'Basket cut off date has been reached',
    MINIMUM_COST_NOT_MET = 'The minimum order value not reached',
    NO_BASKET_ITEMS = 'No items in the basket',
    NO_UNIT_IN_BASKET = 'No unit in basket',
    BASKET_NOT_FOUND = 'Basket not found for user',
    CONTAINS_OUT_OF_RANGE_ITEM = 'Basket contains out of range items',
}
